import { render, staticRenderFns } from "./MainGroup.vue?vue&type=template&id=9989ca0a&"
import script from "./MainGroup.vue?vue&type=script&lang=js&"
export * from "./MainGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QHeader,QToolbar,QBtn,QToolbarTitle,QTooltip,QBtnDropdown,QCard,QImg,QList,QItem,QItemSection,QItemLabel,ClosePopup} from 'quasar'
component.options.components = Object.assign({QHeader,QToolbar,QBtn,QToolbarTitle,QTooltip,QBtnDropdown,QCard,QImg,QList,QItem,QItemSection,QItemLabel}, component.options.components || {})
component.options.directives = Object.assign({ClosePopup}, component.options.directives || {})
